<div [@WindowOpenClose]="windowVisible.getValue() ? 'visible' : 'invisible'" (click)="windowClick()">
  <dialog-header [label]="'Sensor: '+sensor.name+' | '+streamName" [dialogRef]='dialogRef' (mousedown)="windowClick()"
    [object]='this' style="min-width: 650px">
  </dialog-header>
  <div class="side-by-side">
    <div class="left-panel">
      <video-player-selector [sensor]="sensor" [analysedVid]="analysisStream"></video-player-selector>
    
    </div>
    <div *ngIf="canSetChannel || canSetAnalytics" fxLayoutAlign="center center" fxLayout="column" class="right-panel"
      style="gap: 10px;">
      <div fxLayoutAlign="center center" fxLayout="column" style="margin: 5px;">
        <div>Res: {{sensor.res}}</div>
      </div>
      <div *ngIf="canSetAnalytics" fxLayoutAlign="center center" fxLayout="column" style="margin: 5px;">
        <mat-slide-toggle (change)="onAnalyticsClick($event)" [(ngModel)]="analysisToggleState">
        </mat-slide-toggle>
        <div>Send to Analytics</div>
      </div>
      <div *ngIf="canSetAnalytics && analysisToggleState" fxLayoutAlign="center center" fxLayout="column"
        style="margin: 5px;">
        <mat-slide-toggle (change)="onAnalyticsVideoClick($event)" [(ngModel)]="analysisStream">
        </mat-slide-toggle>
        <div>Analyzed Video</div>
      </div>
      <div *ngIf="canSetChannel" fxLayoutAlign="center center" fxLayout="column" style="margin: 5px;">
        <mat-slide-toggle (change)="onZtubeClick($event)" [(ngModel)]="ztubeToggleState" [disabled]="isUpdatingZtubeState">
        </mat-slide-toggle>
        <div>Send to Ztube</div>
      </div> 
       <div *ngIf="canSetDaynamicChannel" fxLayoutAlign="center center" fxLayout="column" style="margin: 5px; margin-top: 15px;">
        <mat-select style="position: unset; max-width: 25%; min-width: 130px; margin-bottom: 5px;" class="identity"
          (selectionChange)="onchannelsDaynamic($event)" [(ngModel)]="selectedChannel"  placeholder="Channels">
          <mat-option [value]="null">Channels</mat-option>
          <mat-option *ngFor="let item of channelsDaynamic" [value]="item.name">{{item.name}}</mat-option>
        </mat-select>
      
      </div>    
    </div>
  </div>
</div>